import { createApp } from "vue";
import { createPinia } from "pinia";
import { Amplify } from "aws-amplify";
import App from "./App.vue";
import awsExports from "./aws-exports";

import * as Sentry from "@sentry/vue";

Amplify.configure(awsExports);
const pinia = createPinia();
const app = createApp(App);

if (process.env.VUE_APP_ENV === "prod") {
  Sentry.init({
    app,
    dsn: "https://5f090bb24d29391e896d44a5aca3a20f@o4507647302303744.ingest.us.sentry.io/4509888781484032",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
  });
  console.log("Initialized");
} else {
  console.log("Not initialized");
}

app.use(pinia);
app.mount("#app");
